export default function Council2022Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>12-20-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-12-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>12-07-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-12-07-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-30-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-11-30-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-22-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-11-22-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-21-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-11-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-16-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-11-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-15-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-11-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-18-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-10-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>09-20-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-09-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>08-16-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-08-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>07-19-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-07-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>06-21-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-06-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>05-09-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-05-09-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>04-19-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-04-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>03-15-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-03-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>02-15-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-02-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-18-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-01-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-04-2022</td>
        <td>
          <a href="../docs/council/minutes/2022/2022-01-04-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
